import React, { useEffect } from "react";
import "./Header-Page.scss";
import { Col, Row, Space } from "antd";
import BreadCrum from "./BreadCrum/BreadCrum";
import { useAppSelector } from "redux/hooks";
const HeaderPage = (props) => {
  const buttons = useAppSelector((state) => state.common.buttonsHeader);
  useEffect(() => {}, [buttons]);
  return (
    <div className="header-page">
      {/* Trang chủ */}
      <Row wrap={false} justify={"space-between"}>
        <Col flex="360px">
          <BreadCrum></BreadCrum>
        </Col>
        <Col flex={"auto"}>
          <Row justify={"end"} style={{ height: "100%" }} gutter={[8, 8]}>
            {buttons.map((button, index) => {
              return <Col key={index}>{button}</Col>;
            })}
          </Row>
        </Col>
      </Row>
    </div>
  );
};
export default HeaderPage;
